import * as React from "react";
/* empty css          */
const Logo = ({ url, className, image, title, tealiumAttributes }) => /* @__PURE__ */ React.createElement(
  "a",
  {
    className: `logo ${className || ""}`,
    href: url,
    title,
    "data-t": "logo-link",
    ...tealiumAttributes
  },
  /* @__PURE__ */ React.createElement("img", { className: "logo__img", src: image.url, alt: image.altText || title, "data-t": "logo-image" })
);
export {
  Logo as default
};
//# sourceMappingURL=Logo.js.map
